// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"0d14a822","148":"4490fc1c","175":"004b85a7","235":"8236a193","470":"10c6b201","536":"3492691f","610":"38b7554b","751":"7bc07cd3","879":"a7cdb708","950":"70d96d40","991":"a41b493d","999":"79f63e2b"}[chunkId] + ".chunk.js";
};